<template>
  <v-card>
    <v-card-title class="mb-0 pb-1">
      Meter Reading Information
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <v-container class="mt-0">
        <v-row>
          <v-col
            sm="4"
            md="3"
            cols="12"
            class="mb-4"
          >
            <details-text-shimmer v-show="isLoading" />
            <div v-show="!isLoading">
              <h4 class="font-weight-light">
                Month
              </h4>
              <h4 class="font-weight-medium">
                {{ meterReading.month | formatMonth }}
              </h4>
            </div>
          </v-col>
          <v-col
            sm="4"
            md="3"
            cols="12"
          >
            <details-text-shimmer v-show="isLoading" />
            <div v-show="!isLoading">
              <h4 class="font-weight-light">
                Reading
              </h4>
              <h4 class="font-weight-medium">
                {{ meterReading.current_reading }}
              </h4>
            </div>
          </v-col>
          <v-col
            sm="4"
            md="3"
            cols="12"
          >
            <details-text-shimmer v-show="isLoading" />
            <div v-show="!isLoading">
              <h4 class="font-weight-light">
                Previous Reading
              </h4>
              <h4 class="font-weight-medium">
                {{ meterReading.previous_reading }}
              </h4>
            </div>
          </v-col>
          <v-col
            sm="4"
            md="3"
            cols="12"
          >
            <details-text-shimmer
              v-show="isLoading"
              class="mt-2 mb-3"
            />
            <div v-show="!isLoading">
              <h4 class="font-weight-light">
                Bill
              </h4>
              <h4 class="font-weight-medium">
                {{ meterReading.bill | formatCurrency }}
              </h4>
            </div>
          </v-col>
          <v-col
            sm="4"
            md="3"
            cols="12"
          >
            <details-text-shimmer
              v-show="isLoading"
              class="mt-2 mb-3"
            />
            <div v-show="!isLoading">
              <h4 class="font-weight-light">
                Reading Date
              </h4>
              <h4 class="font-weight-medium">
                {{ meterReading.created_at | formatDate }}
              </h4>
            </div>
          </v-col>
          <v-col
            sm="4"
            md="3"
            cols="12"
          >
            <details-text-shimmer
              v-show="isLoading"
              class="mt-2 mb-3"
            />
            <div v-show="!isLoading">
              <h4 class="font-weight-light">
                Status
              </h4>
              <h4 class="font-weight-medium">
                {{ meterReading.status | formatMeterReadingStatus }}
              </h4>
            </div>
          </v-col>
          <v-col
            v-if="!isLoading"
            cols="12"
            md="6"
          >
            <h4 class="font-weight-light">
              Billed units
            </h4>
            <h4>{{ meterReading.adjusted_units != null ? meterReading.adjusted_units : meterReading.current_reading - meterReading.previous_reading }}</h4>
            <p v-if="meterReading.adjusted_units != null">
              Estimated: {{ meterReading.estimation_basis }}
            </p>
            <p v-if="meterReading.reading_baseline">
              Opening / reset baseline
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import DetailsTextShimmer from '@/components/partials/shimmers/DetailsTextShimmer.vue'

export default {
  components: {
    'details-text-shimmer': DetailsTextShimmer,
  },
  props: {
    meterReading: {
      type: Object,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style>

</style>
